export enum EtatPageZoneDeTravail {
	RESERVER_BUREAU = 'RESERVER_BUREAU',
	VISIONNER_TAUX = 'VISIONNER_TAUX'
}
